import { DomainRegistry } from "../../../../domain";
import {
  IBehaviorDocumentEditorRegistererPostRegistrationApplicationConfiguration,
  IBehaviorDocumentEditorRegistererPostRegistrationApplicationExecuteConditionConfiguration,
  IBehaviorDocumentEditorRegistererPostRegistrationConfiguration,
} from "../../../../domain/configuration";
import { DocumentAttributes } from "../../../../domain/document";
import { ApplicationLaunchRequest } from "../../../../domain/localhost/items";
import { Dictionary } from "../../../../domain/system";
import { User } from "../../../../domain/user";
import { AsyncUtility } from "../../../../utilities";

export class PostRegistrationApplicationLauncher {
  constructor(private _configuration: IBehaviorDocumentEditorRegistererPostRegistrationConfiguration) {
  }
  
  public async launch(user: User, attributes: DocumentAttributes, documentId: number, isTemporary: boolean, withPrinting: boolean): Promise<void> {
    // TODO: configure
    // 現状は直接記載側のみ起動が可能になっている
    if (!attributes.behavior.shouldExecutePostRegistrationApplication) { return; }
    
    // 将来的には一回のUrlSchemeで起動できたほうがよさそう
    for (const application of this._configuration.applications) {
      this.launchApplication(user, attributes, documentId, isTemporary, withPrinting, application);
    }
  }

  private async launchApplication(user: User, attributes: DocumentAttributes, documentId: number, isTemporary: boolean, withPrinting: boolean, application: IBehaviorDocumentEditorRegistererPostRegistrationApplicationConfiguration): Promise<void> {
    if (!application.isEnable || this.isSkipCondition(isTemporary, withPrinting, application.executeCondition)) { return; }
    const service = DomainRegistry.localhost.getApplicationService();
    const params = new Dictionary<string, string>();
    params.set("action", "launchApplication");
    const request = this.createApplicationLaunchRequest(user, attributes, documentId, application);
    await service.launchWithKey(null, params, request);
    await AsyncUtility.sleep(300);
  }

  private isSkipCondition(isTemporary: boolean, withPrinting: boolean, condition: IBehaviorDocumentEditorRegistererPostRegistrationApplicationExecuteConditionConfiguration) {
    return (condition.registration === "register" && isTemporary)
      || (condition.registration === "registerAsTemporary" && !isTemporary)
      || (condition.printing === "withPrinting" && !withPrinting)
      || (condition.printing === "withoutPrinting" && withPrinting);
  }

  private createApplicationLaunchRequest(user: User, attributes: DocumentAttributes, documentId: number, application: IBehaviorDocumentEditorRegistererPostRegistrationApplicationConfiguration): ApplicationLaunchRequest {
    const request = new ApplicationLaunchRequest();
    request.modulePath = application.modulePath;
    request.argumentsText = this.replaceValues(user, application.parameter, attributes, documentId);
    return request;
  }

  private replaceValues(user: User, parameter: string, attributes: DocumentAttributes, documentId: number): string {
    if (!parameter) { return parameter; }
    return parameter
      .replace(/%USERCODE%/g, user.id)
      .replace(/%USERID%/g, user.id)
      .replace(/%PATIENTCODE%/g, attributes.patient.id)
      .replace(/%PATIENTID%/g, attributes.patient.id)
      .replace(/%DOCUMENTID%/g, documentId.toString());
  }
}
